const config = {
  title: 'Tilli : votre Couturier à Domicile à Paris, Marseille, Lyon, Aix, Metz',
  // eslint-disable-next-line max-len
  description: 'Tilli : votre Couturier à Domicile. Pour toutes vos retouches de vêtement. Dispo soir et week-end à Paris, Lyon, Marseille, Aix et Metz. Réservez dès maintenant sur notre site ou notre app !',
  photo: '/photo-header.jpg',
  baseUrl: 'https://tilli.fr',
};

export default config;
